import lodash from 'lodash';
import {
    call, put, takeEvery, select,
} from 'redux-saga/effects';
import { getLeadsDivisions } from '../../requests/get_leads_divisions_request';
import {
    getLeadsDivisionsSuccess,
    getLeadsDivisionsFailure,
} from '../actions/get_leads_divisions.actions';
import { GET_LEADS_DIVISIONS } from '../constants/get_leads_divisions.constants';

function* getLeadsDivisionsRequest() {
    const store = yield select();
    const userDivisions = lodash.get(store, 'App.App_content.user.divisions') || [];
    const divisionsIds = userDivisions.map(division => division._id);

    const { result, options } = yield call(getLeadsDivisions, divisionsIds);

    result
        ? yield put(getLeadsDivisionsSuccess(options))
        : yield put(getLeadsDivisionsFailure('Something gone wrong!'));
}

export default function* getLeadsDivisionsSaga() {
    yield takeEvery(GET_LEADS_DIVISIONS, getLeadsDivisionsRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/sagas/get_lead_divisions.saga.js